"use strict";

import Point from "ol/geom/Point";
import LineString from "ol/geom/LineString";
import LinearRing from "ol/geom/LinearRing";
import Polygon from "ol/geom/Polygon";
import Circle from "ol/geom/Circle";
import MultiPoint from "ol/geom/MultiPoint";
import MultiLineString from "ol/geom/MultiLineString";
import MultiPolygon from "ol/geom/MultiPolygon";
import GeometryCollection from "ol/geom/GeometryCollection";

/**
 * @classdesc
 * Geometrie-Factory auf Basis der Openlayers Kartenbibliothek.
 *
 * @class
 * @memberof gc.gis.geom
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.geom.OLGeometryFactory = function()
{
};

/**
 * Erzeugt eine Geometrie-Implementierung auf Basis der Openlayers Kartenbibliothek.
 *
 * @param {Geometry} ol_geometry Openlayers Geometrie-Objekt
 * @return {gc.gis.geom.GCGeometry}
 */
gc.gis.geom.OLGeometryFactory.prototype.createGeometry = function(ol_geometry)
{
	if (ol_geometry instanceof Point) {
		return this.createPoint(ol_geometry);
	}
	else if (ol_geometry instanceof LineString) {
		return this.createLineString(ol_geometry);
	}
	else if (ol_geometry instanceof LinearRing) {
		return this.createLinearRing(ol_geometry);
	}
	else if (ol_geometry instanceof Polygon) {
		return this.createPolygon(ol_geometry);
	}
	else if (ol_geometry instanceof Circle) {
		return this.createCircle(ol_geometry);
	}
	else if (ol_geometry instanceof MultiPoint) {
		return this.createMultiPoint(ol_geometry);
	}
	else if (ol_geometry instanceof MultiLineString) {
		return this.createMultiLineString(ol_geometry);
	}
	else if (ol_geometry instanceof MultiPolygon) {
		return this.createMultiPolygon(ol_geometry);
	}
	else if (ol_geometry instanceof GeometryCollection) {
		return this.createGeometryCollection(ol_geometry);
	}

	throw new gc.gis.error.GCError('Unsupported or invalid geometry.');
};

/**
 * Erzeugt eine Punkt-Geometrie-Implementierung auf Basis der Openlayers Kartenbibliothek.
 *
 * @param {Point} [ol_point] Openlayers Punkt-Instanz
 * @return {gc.gis.geom.GCPoint}
 */
gc.gis.geom.OLGeometryFactory.prototype.createPoint = function(ol_point)
{
	return new gc.gis.geom.OLPoint(ol_point);
};

/**
 * Erzeugt eine Linien-Geometrie-Implementierung auf Basis der OpenLayers Kartenbibliothek.
 *
 * @param {LineString} [ol_linestring] OpenLayers LineSting-Instanz
 * @return {gc.gis.geom.GCLineString}
 */
gc.gis.geom.OLGeometryFactory.prototype.createLineString = function(ol_linestring)
{
	return new gc.gis.geom.OLLineString(ol_linestring);
};

/**
 * Erzeugt eine Ring-Geometrie-Implementierung auf Basis der OpenLayers Kartenbibliothek.
 *
 * @param {LinearRing} [ol_linearring] OpenLayers LinearRing-Instanz
 * @return {gc.gis.geom.GCLinearRing}
 */
gc.gis.geom.OLGeometryFactory.prototype.createLinearRing = function(ol_linearring)
{
	return new gc.gis.geom.OLLinearRing(ol_linearring);
};

/**
 * Erzeugt eine Polygon-Geometrie-Implementierung auf Basis der OpenLayers Kartenbibliothek.
 *
 * @param {Polygon} [ol_polygon] OpenLayers Polygon-Instanz
 * @return {gc.gis.geom.GCPolygon}
 */
gc.gis.geom.OLGeometryFactory.prototype.createPolygon = function(ol_polygon)
{
	return new gc.gis.geom.OLPolygon(ol_polygon);
};

/**
 * Erzeugt eine Circle-Geometrie-Implementierung auf Basis der OpenLayers Kartenbibliothek.
 *
 * @param {Circle} [ol_circle] OpenLayers Kreis-Instanz
 * @return {gc.gis.geom.GCCircle}
 */
gc.gis.geom.OLGeometryFactory.prototype.createCircle = function(ol_circle)
{
	return new gc.gis.geom.OLCircle(ol_circle);
};

/**
 * Erzeugt eine MultiPunkt-Geometrie-Implementierung auf Basis der OpenLayers Kartenbibliothek.
 *
 * @param {MultiPoint} [ol_multipoint] OpenLayers MultiPunkt-Instanz
 * @return {gc.gis.geom.GCMultiPoint}
 */
gc.gis.geom.OLGeometryFactory.prototype.createMultiPoint = function(ol_multipoint)
{
	return new gc.gis.geom.OLMultiPoint(ol_multipoint);
};

/**
 * Erzeugt eine MultiLinien-Geometrie-Implementierung auf Basis der OpenLayers Kartenbibliothek.
 *
 * @param {MultiLineString} [ol_multilinestring] OpenLayers MultiLinien-Instanz
 * @return {gc.gis.geom.GCMultiLineString}
 */
gc.gis.geom.OLGeometryFactory.prototype.createMultiLineString = function(ol_multilinestring)
{
	return new gc.gis.geom.OLMultiLineString(ol_multilinestring);
};

/**
 * Erzeugt eine MultiPolygon-Geometrie-Implementierung auf Basis der OpenLayers Kartenbibliothek.
 *
 * @param {MultiPolygon} [ol_multipolygon] OpenLayers MultiPolygon-Instanz
 * @return {gc.gis.geom.GCMultiPolygon}
 */
gc.gis.geom.OLGeometryFactory.prototype.createMultiPolygon = function(ol_multipolygon)
{
	return new gc.gis.geom.OLMultiPolygon(ol_multipolygon);
};

/**
 * Erzeugt eine Geometrie-Collection-Implementierung auf Basis der OpenLayers Kartenbibliothek.
 *
 * @param {GeometryCollection} [ol_collection] OpenLayers Geometrie-Collection-Instanz
 * @return {gc.gis.geom.GCGeometryCollection}
 */
gc.gis.geom.OLGeometryFactory.prototype.createGeometryCollection = function (ol_collection)
{
	return new gc.gis.geom.OLGeometryCollection(ol_collection);
};